<template>
  <main class="container-1">
    <div class="container-header">
      <Breadcrumb v-bind:links="routesBread"></Breadcrumb>
      <h2>Nueva capa</h2>
    </div>
    <div class="container-body">
      <div class="selection-mode">
        <label>
          <input type="radio" v-model="layerCreationMode" value="arcgis" /> ArcGIS
        </label>
        <label>
          <input type="radio" v-model="layerCreationMode" value="geoserver" /> GeoServer
        </label>
      </div>
      <component
        :is="currentForm"
        :categories="categories"
        :layerCreationMode="layerCreationMode"
      />
    </div>

    
  </main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from "@/components/Breadcrumb.vue";

import { formatter } from "@/components/mixin/formatter.js";
import { restLayer } from "@/components/mixin/restLayer.js";
import { restCategory } from "@/components/mixin/restCategory.js";
import FormularioGeoserver from "@/views/layers/addLayerForm/FormularioGeoserver";
import FormularioArcgis from "@/views/layers/addLayerForm/FormularioArcgis";

export default {
  name: "test",
  mixins: [formatter, restLayer, restCategory],
  data() {
    return {
      layerCreationMode: "arcgis",
    };
  },
  components: {
    Breadcrumb,
    FormularioGeoserver,
    FormularioArcgis,
  },
  computed: {
    currentForm() {
      console.log("layerCreationMode", this.layerCreationMode);
      const formMap = {
        geoserver: "FormularioGeoserver",
        arcgis: "FormularioArcgis",
      };
      return formMap[this.layerCreationMode] || null;
    },
    routesBread: function () {
      return [{ name: "Capas", path: "/capas" }, { name: "Nueva capa" }];
    },
    categoriesIncluded: function () {
      let list = "included:";
      for (let i = 0; i < this.categories.length; i++) {
        list = list + this.categories[i].id.toString() + ",";
      }
      return list;
    },
  },
  props: [],
  methods: {
    onClickGoBack: function () {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/capas/");
    },
    layerCategoryNameByID: function (idLayer) {
      var category = this.categories.find(function (element) {
        return element.id == idLayer;
      });
      return category.name;
    },
    onClickGoNext: function () {
      var that = this;
      this.$validator.validateAll().then(function (response) {
        if (response) {
          that.layer.provider.name = that.layerCreationMode; // geoserver o arcgis
          that.layer.provider.geoserverdata.filename = that.cleanString(
            that.layer.provider.geoserverdata.filename.toLowerCase()
          );
          that.layer.provider.geoserverdata.workspace = that.cleanString(
            that.layer.provider.geoserverdata.workspace.toLowerCase()
          );
          that.layer.provider.geoserverdata.datastore = that.cleanString(
            that.layer.provider.geoserverdata.datastore.toLowerCase()
          );
          console.log("1 put layer", that);
          that.postLayer();
        }
      });
    },

  },
  updated() {},
  created() {
    this.$store.getters.getPermissions.layers
      ? true
      : this.$router.push("/pagina-no-encontrada");
  },
  mounted() {
    this.getCategoriesNoPages();
  },

};
</script>

<style lang="scss" scoped>

.search-tools {
  display: grid;
  grid-template-columns: min-content auto;
  grid-column-gap: 0.5em;
  align-items: end;
}

/* Reset de grid-area para evitar superposición en container-1 */
.container-header,
.container-body {
  grid-area: auto !important;
  grid-column: 1 / -1;
}

.container-body {
  width: 95%;
  max-width: 1400px;
  margin: 0 auto;
}

.selection-mode {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  padding-left: 10px;
}

.selection-mode label {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 1rem;
}

.selection-mode input[type="radio"] {
  margin-right: 8px;
  transform: scale(1.2);
}
</style>
